import { render, staticRenderFns } from "./LayoutPayBoxSection.vue?vue&type=template&id=8ef9e28c&scoped=true&"
import script from "./LayoutPayBoxSection.vue?vue&type=script&lang=js&"
export * from "./LayoutPayBoxSection.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPayBoxSection.vue?vue&type=style&index=0&id=8ef9e28c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef9e28c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ef9e28c')) {
      api.createRecord('8ef9e28c', component.options)
    } else {
      api.reload('8ef9e28c', component.options)
    }
    module.hot.accept("./LayoutPayBoxSection.vue?vue&type=template&id=8ef9e28c&scoped=true&", function () {
      api.rerender('8ef9e28c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box/components/LayoutPayBoxSection.vue"
export default component.exports